/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Request_ReadyInputs */

const en_invoice_request_ready = /** @type {(inputs: Invoice_Request_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your invoice is ready to download`)
};

const pl_invoice_request_ready = /** @type {(inputs: Invoice_Request_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktura gotowa do pobrania`)
};

/**
* | output |
* | --- |
* | "Your invoice is ready to download" |
*
* @param {Invoice_Request_ReadyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_request_ready = /** @type {((inputs?: Invoice_Request_ReadyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Request_ReadyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_request_ready(inputs)
	return en_invoice_request_ready(inputs)
});